import type { SxProps, Theme } from '@mui/material/styles';

export const sliderBoxSx: SxProps<Theme> = {
  px: 3,
};

export const getSliderSx = (theme: Theme): SxProps<Theme> => ({
  color: theme.palette.accent.main,
  '& .MuiSlider-thumb': { backgroundColor: theme.palette.accent.main },
  '& .MuiSlider-track': { backgroundColor: theme.palette.accent.main },
  '& .MuiSlider-rail': { backgroundColor: '#E0DFE5' },
});
